import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";

import PageHeading from "../../../components/common/PageHeading";
import FormAction from "../../../components/common/FormAction";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import CurrentLoginLocations from "./CurrentLoginLocations";
import Footer from "../../../components/common/Footer";
import ConfirmationBox from "../../../components/common/ConfirmationBox";
import { notifications } from "../../../data/notifications";

import {
  Form,
  Input,
  Checkbox,
  Button,
  Card,
  Row,
  Col,
  Collapse,
  message,
  Select,
} from "antd";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { FaQuestionCircle } from "react-icons/fa";
import TextArea from "antd/es/input/TextArea";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  QuerySnapshot,
  where,
  updateDoc,
} from "@firebase/firestore";
import { auth, db } from "../../../firebase.js";

import "./MySettings.css";
import Notifications from "./Notifications";
import EditEelectronicSignature from "../../../components/common/EditElectronicSignature";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

const { Panel } = Collapse;

function MySettings() {
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [uid, setId] = useState("");

  const { id } = useParams();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const onCancelModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmationBox = () => {
    setIsConfirmationBoxOpen(true);
  };

  // console.log(notifications.leasing[0]);

  const mySettingsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        <span onClick={showModal}>Edit Electronic Signature</span>,
        "1",
        "",
        "",
        ""
      ),
      RightBarMethod("Availability", "2", "", "", "/showing-availability"),
    ]),
  ];

  // ######## Fetching User Data ######
  const role = [
    { label: "President", value: "President" },
    { label: "Accountant", value: "Accountant" },
    { label: "Property Manager", value: "Property Manager" },
    { label: "On-Site Manager", value: "On-Site Manager" },
    { label: "Leasing Agent", value: "Leasing Agent" },
    { label: "Accounts Payable", value: "Accounts Payable" },
    { label: "Accounts Receivabl", value: "Accounts Receivabl" },
    { label: "View Only", value: "View Only" },
    { label: "Maintenance Coordinator", value: "Maintenance Coordinator" },
    { label: "Maintenance Tech", value: "Maintenance Tech" },
    { label: "Regional Manager", value: "Regional Manager" },
    {
      label: "Assistant Property Manager",
      value: "Assistant Property Manager",
    },
    { label: "Assistant Leasing Agent", value: "Assistant Leasing Agent" },
  ];

  const [isData, setIsData] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [checkRole, setCheckRole] = useState({});

  const [data, setData] = useState([]);

  console.log("its my id:",uid)
    
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res?.companyName);
      });
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  useEffect(() => {
    if(id){
      setId(id)
    }else{
      setId(user?.uid)
    }

  }, [id]);


  const fetchUserName = (uid) => {
    if (companyName) {
      try {
        const companiesRef = collection(db, "companies");
        const companyDocRef = doc(companiesRef, companyName);
        const usersRef = collection(companyDocRef, "users");
        const userDocRef = doc(usersRef, uid);

        getDoc(userDocRef)
          .then((docSnapshot) => {
            if (docSnapshot.exists()) {
              const user = docSnapshot.data();
              setData(user);
              setIsData(true);
              setCheckRole(user?.profile);
            } else {
              console.log("User not found");
              // Handle user not found case
            }
          })
          .catch((error) => {
            console.log("Error getting user document: ", error);
          });
      } catch (err) {
        console.error(err);
        // alert("An error occurred while fetching user data");
      }
    }
  };

  console.log("companyName:", companyName);

  const ok = "OK";

  const onFinish = async (values) => {
    console.log("Vale OKKKK", ok);
    console.log("Success:", values);
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const userRef = collection(companyDocRef, "users");

    const updateUser = async (updatedData) => {
      try {
        const docRef = doc(userRef, uid);
        await updateDoc(docRef, updatedData);

        console.log("User updated successfully");
        message.success("User Setting Updated Successfully.", 3);
      } catch (error) {
        console.error("Error updating user:", error);
        message.error("Something is went wrong!", 3);
      }
    };
    const userDocRef = doc(userRef, uid);
    const userDataSnapshot = await getDoc(userDocRef);
    const userData = userDataSnapshot.data();
    // setCheckRole(userData.profile.role);

    const updatedProfile = {
      ...userData.profile,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      // role: values.role !== "" ? values.role : userData.profile.role,
    };

    // remove comment if you want to fire the update query....
    const updateUserValues = {
      profile: updatedProfile,

      notifications: {
        Leasing: {
          isRntalApplictinRecved: {
            email: values.isRntalApplictinRecved || false,
          },
          isOnlineLeasesReady: {
            email: values.isOnlineLeasesReady || false,
          },
          assignedShowingUpdates: {
            email: values.assignedShowingUpdates || false,
          },
          isReceivedGuestCards: {
            email: values.isReceivedGuestCards || false,
          },
        },

        maintenance: {
          rqstMaintenance: {
            email: values.rqstMaintenance || false,
          },
          rqstCancellation: {
            email: values.rqstCancellation || false,
          },
          assignedWorkOrder: {
            email: values.assignedWorkOrder || false,
            mobilePush: values.mobilePushassignedWorkOrder || false,
          },
          trackedAcceptance: {
            email: values.trackedAcceptance || false,
            mobilePush: values.mobilePushtrackedAcceptance || false,
          },
          vendorWorkOrderDecline: {
            email: values.vendorWorkOrderDecline || false,
            mobilePush: values.mobilePushvendorWorkOrderDecline || false,
          },
          vendorScheduledTime: {
            email: values.vendorScheduledTime || false,
            mobilePush: values.mobilePushvendorScheduledTime || false,
          },
          vendorWorkOrderNote: {
            email: values.vendorWorkOrderNote || false,
            mobilePush: values.mobilePushvendorWorkOrderNote || false,
          },
          vndorWrkOrdrStatusChnge: {
            email: values.vndorWrkOrdrStatusChnge || false,
            mobilePush: values.mobilePushvndorWrkOrdrStatusChnge || false,
          },
          vndorWrkOrdrEstimate: {
            email: values.vndorWrkOrdrEstimate || false,
            mobilePush: values.mobilePushvndorWrkOrdrEstimate || false,
          },
          workOrdrFllwUpRched: {
            email: values.workOrdrFllwUpRched || false,
            mobilePush: values.mobilePushworkOrdrFllwUpRched || false,
          },
          tenantInspctnSignd: {
            email: values.tenantInspctnSignd || false,
          },
          invntryReorderRched: {
            email: values.invntryReorderRched || false,
          },
        },
        communication: {
          lastCntctTxtRecved: {
            email: values.lastCntctTxtRecved || false,
            mobilePush: values.mobilePushlastCntctTxtRecved || false,
          },
        },
        accounting: {
          rejctdTenantPymnts: {
            email: values.rejctdTenantPymnts || false,
          },
          rjctedOutboundECheck: {
            email: values.rjctedOutboundECheck || false,
          },
          ownerCntributionAlrts: {
            email: values.ownerCntributionAlrts || false,
          },
          newSmartBillInvoices: {
            email: values.newSmartBillInvoices || false,
          },
          skippedBillsDueFunds: {
            email: values.skippedBillsDueFunds || false,
          },
        },

        associations: {
          approvalActivity: {
            email: values.approvalActivity || false,
          },
        },
        sales: {
          agreementsCountersign: {
            email: values.agreementsCountersign || false,
          },
        },
        clientExperience: {
          unrecgnizdActivtionAttmpt: {
            email: values.unrecgnizdActivtionAttmpt || false,
          },

          moveOutFinalized: {
            email: values.moveOutFinalized || false,
          },
          rentersInsurancActvty: {
            email: values.rentersInsurancActvty || false,
          },
        },

        notes: {
          noteMentions: {
            email: values.noteMentions || false,
            mobilePush: values.mobilePushnoteMentions || false,
          },
        },
      },
      emailSettings: {
        emailSignature: values.emailSignature || "",
        signatureDescription: values.signatureDescription || "",
        sendMessageEmail: values.sendMessageEmail || "",
      },
      textingSettings: {
        useCustomText: values.useCustomText || "",
        unreadCountInMenue: values.unreadCountInMenue || "",
      },
      maintenanceSettings: {
        trackAllOrders: values.trackAllOrders || "",
      },
      VacancyPostingContactInfo: {
        vaccancyEmail: values.vaccancyEmail || "",
        vaccancyPhone: values.vaccancyPhone || "",
        vaccancyExtension: values.vaccancyExtension || "",
      },
    };

    await updateUser(updateUserValues);
    try {
      message.success("User Setting Updated SuccessFully.", 3);
    } catch (error) {
      console.error(error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Please fill in all the required fields!", 3);
  };
  const {
    profile,
    emailSettings,
    textingSettings,
    maintenanceSettings,
    VacancyPostingContactInfo,
  } = data;

  // const { Leasing } = notifications;

  const defaultValues = {
    // communication initialvalues ....

    lastCntctTxtRecved:
      data?.notifications?.communication?.lastCntctTxtRecved?.email || false,
    mobilePushlastCntctTxtRecved:
      data?.notifications?.communication?.lastCntctTxtRecved?.mobilePush ||
      false,
    // sales initialvalues ....
    agreementsCountersign:
      data?.notifications?.sales?.agreementsCountersign?.email || false,
    // Notes initialvalues ....
    noteMentions: data?.notifications?.notes?.noteMentions?.email || false,
    mobilePushnoteMentions:
      data?.notifications?.notes?.noteMentions?.mobilePush || false,

    approvalActivity:
      data?.notifications?.associations?.approvalActivity?.email || false,

    // Profile initialvalues ....
    email: profile?.email ? profile.email : "",
    firstName: profile?.firstName ? profile?.firstName : "",
    lastName: profile?.lastName ? profile?.lastName : "",
    authPhoneNumber: data?.phoneNumber ? data?.phoneNumber : "",
    role: data?.role ? data?.role : "",
    // Email Settings initialvalues ....

    emailSignature: emailSettings?.emailSignature || false,
    signatureDescription: emailSettings?.signatureDescription || "",
    sendMessageEmail: emailSettings?.sendMessageEmail || "",
    // Texting Settings initialvalues ....

    useCustomText: textingSettings?.useCustomText || false,
    unreadCountInMenue: textingSettings?.unreadCountInMenue || false,
    // Maintenance Settings initialvalues ....

    trackAllOrders: maintenanceSettings?.trackAllOrders || false,
    // Vacancy Posting Contact Info initialvalues ....

    vaccancyEmail: VacancyPostingContactInfo?.vaccancyEmail || "",
    vaccancyPhone: VacancyPostingContactInfo?.vaccancyPhone || "",
    vaccancyExtension: VacancyPostingContactInfo?.vaccancyExtension || "",
  };
  const leasingValues = data?.notifications?.Leasing || {};
  const AccountingValues = data?.notifications?.accounting || {};
  const clientExperienceValues = data?.notifications?.clientExperience || {};
  const maintenanceValues = data?.notifications?.maintenance || {};

  for (let prop in leasingValues) {
    defaultValues[prop] = leasingValues[prop]?.email || false;
  }

  for (let prop in AccountingValues) {
    defaultValues[prop] = AccountingValues[prop]?.email || false;
  }
  for (let prop in clientExperienceValues) {
    defaultValues[prop] = clientExperienceValues[prop]?.email || false;
  }
  for (let prop in maintenanceValues) {
    defaultValues[prop] = maintenanceValues[prop]?.email || false;
  }

  for (let prop in maintenanceValues) {
    defaultValues["mobilePush" + prop] =
      maintenanceValues[prop]?.mobilePush || false;
  }

  useEffect(() => {
    fetchUserName(uid);
  }, [companyName]);

  return (
    <>
      <div className="page-container">
        <div className="my-settings-container main-container">
          {checkRole && checkRole.email && (
            <PageHeading
              heading={
                checkRole && checkRole.email && checkRole.email !== user.email
                  ? `User Settings for ${checkRole.email}`
                  : "My Settings"
              }
            />
          )}

          {isData && (
            <Form
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              colon={false}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={defaultValues}
            >
              {/* Notifications container start */}
              <div
                className="collapse-container"
                style={{ marginBottom: "30px" }}
              >
                {/* Profile form container start*/}
                <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Profile" bordered={false}>
                      <Form.Item
                        label="Email Address"
                        name="email"
                        rules={[
                          {
                            required: true,
                            message: "this.getinstance@gmail.com",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        label="First Name"
                        name="firstName"
                        rules={[{ required: true, message: "aamir" }]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        label="Last Name"
                        name="lastName"
                        rules={[{ required: true, message: "ali" }]}
                      >
                        <Input />
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
                  </div>
                {/* Notifications container start */}
                <div
                  className="collapse-container"
                  style={{ marginBottom: "30px" }}
                >
                  <Collapse
                    expandIcon={({ isActive }) =>
                      isActive ? <RiArrowDownSLine /> : <RiArrowUpSLine />
                    }
                  >
                    <Panel header="Notifications" key="1">
                      <div className="notifications-conatainer">
                        <Notifications
                          heading="Leasing"
                          data={notifications.leasing}
                        />
                        <Notifications
                          heading="Maintenance"
                          data={notifications.maintenance}
                        />
                        <Notifications
                          heading="Communication"
                          data={notifications.communication}
                        />
                        <Notifications
                          heading="Payments and Accounting"
                          data={notifications.accounting}
                        />
                        <Notifications
                          heading="Client Experience"
                          data={notifications.clientExperience}
                        />
                        <Notifications
                          heading="Associations"
                          data={notifications.associations}
                        />
                        <Notifications
                          heading="Sales"
                          data={notifications.sales}
                        />
                        <Notifications
                          heading="Notes"
                          data={notifications.notes}
                        />
                      </div>
                    </Panel>
                  </Collapse>
                </div>
                {/* Email settings container start */}
                <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Email Settings" bordered={false}>
                      <Form.Item
                        label=" "
                        name="emailSignature"
                        valuePropName="checked"
                      >
                        <Checkbox>Use custom email signature</Checkbox>
                      </Form.Item>
                      <Form.Item
                        label="TextArea"
                        colon={false}
                        name={"signatureDescription"}
                      >
                        <TextArea rows={4} />
                      </Form.Item>
                      <Form.Item
                        label="Send messages to this email"
                        name={"sendMessageEmail"}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item label=" ">
                        <span className="text">
                          Replies to emails sent from the Tenant, Guest Card,
                          Owner, Unit, and Property pages will go to this email
                          address. If left blank, email replies will go to the
                          email address associated with your AppFolio account.
                        </span>
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
                <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Texting Settings" bordered={false}>
                      <Form.Item
                        name="useCustomText"
                        label=" "
                        valuePropName="checked"
                      >
                        <Checkbox>Use custom text message signature</Checkbox>
                      </Form.Item>
                      <Form.Item
                        name="unreadCountInMenue"
                        label=" "
                        valuePropName="checked"
                      >
                        <Checkbox>
                          Enable text message unread count in menu bar
                        </Checkbox>
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
                {/* Maintenance settings container start */}
                <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Maintenance Settings" bordered={false}>
                      <Form.Item
                        name="trackAllOrders"
                        label=" "
                        valuePropName="checked"
                      >
                        <Checkbox>Track all work orders by default</Checkbox>
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
                {/* Vacancy Posting container start */}
                <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Vacancy Posting Contact Info" bordered={false}>
                      <Form.Item label="Email Address" name={"vaccancyEmail"}>
                        <Input />
                      </Form.Item>
                      <Form.Item label="Phone" name={"vaccancyPhone"}>
                        <Input />
                      </Form.Item>
                      <Form.Item label="Extension" name={"vaccancyExtension"}>
                        <Input />
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
                {/* Change Password container start */}
                {/* <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Change Password" bordered={false}>
                      <Form.Item
                        label="Current Password"
                        name={"currentPassowrd"}
                      >
                        <Input type="password" />
                      </Form.Item>
                      <Form.Item label="New Password" name={"newPassword"}>
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Confirm New Password"
                        name={"confirmNewPassword"}
                      >
                        <Input />
                      </Form.Item>
                    </Card>
                  </Col>
                </Row> */}
                {/* Two Factor Authentication container start */}
                <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Two Factor Authentication" bordered={false}>
                      <Form.Item label="Enabled" name={"factorAuthEnabled"}>
                        <Checkbox></Checkbox> <br />
                      </Form.Item>
                      <Form.Item label=" ">
                        <span className="text">
                          By company policy, users cannot disable Two Factor
                          Authentication
                        </span>
                      </Form.Item>
                      <Form.Item label="Phone Number" name={"authPhoneNumber"}>
                        <Input />
                      </Form.Item>
                      <Form.Item label=" ">
                        <Button type="link" onClick={handleConfirmationBox}>
                          Change Phone number
                        </Button>
                      </Form.Item>
                    </Card>
                  </Col>
                </Row>
                {/* Current Locations container start */}
                <Row style={{ marginBottom: "30px" }}>
                  <Col span={24}>
                    <Card title="Where You Logged in Recently" bordered={false}>
                      <CurrentLoginLocations />
                      <Button type="link" className="logme-out">
                        <span>Log me out of all devices</span>
                        <FaQuestionCircle size={12} />
                      </Button>
                    </Card>
                  </Col>
                </Row>
                <FormAction submit={"submit"} />
              </Form>
            )}
            <Footer />
          </div>
        </div>
        <div className="RightSidebar">
          <RightBar RightBarData={mySettingsRightBar} />
        </div>
        {isConfirmationBoxOpen ? (
          <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
            <h2>Please Confirm</h2>
            <p>
              Changing your phone number requires you to log in again. Do you
              want to change your phone number?
            </p>
            <div className="action-buttons">
              <button
                className="blue"
                onClick={() => setIsConfirmationBoxOpen(false)}
              >
                Ok
              </button>
              <button
                className="cancel"
                onClick={() => setIsConfirmationBoxOpen(false)}
              >
                Cancel
              </button>
            </div>
          </ConfirmationBox>
        ) : null}

        <EditEelectronicSignature
          showModal={isModalOpen}
          cancelModal={onCancelModal}
        />
      </>
    )
}

export default MySettings;
